// src/components/layout/ServicesLayout.jsx
import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate, Link } from 'react-router-dom';
import {
    Sidebar,
    Menu,
    MenuItem,
    SubMenu,
    ProSidebarProvider
} from 'react-pro-sidebar';
import {
    FaSearch,
    FaAd,
    FaDatabase,
    FaChess,
    FaPalette,
    FaBrain,
    FaGlobeAmericas,
    FaCogs,
    FaShoppingCart,
    FaGlobe,
    FaSearchDollar,
    FaThumbsUp,
    FaRobot,
    FaFacebook,
    FaHandshake,
    FaChartBar,
    FaTags,
    FaClipboardCheck,
    FaCalendarAlt,
    FaHome,
    FaPlane,
    FaPaintBrush,
    FaChartLine,
    FaLaptopCode,
    FaVideo,
    FaEnvelope,
    FaBars,
    FaTimes,
    FaLayerGroup,
    FaChevronRight,
    FaPhone,
    FaClock,
    FaUser,
    FaChevronDown
} from 'react-icons/fa';
import servicesData from '../../data/services';
import TopNav from '../common/ServicesHeader'
import { Button } from 'reactstrap';
// Icon mapping based on your servicesData
const iconMap = {
    // Category icons
    'fas fa-search': FaSearch,
    'fas fa-ad': FaAd,
    'fas fa-database': FaDatabase,
    'fas fa-chess': FaChess,
    'fas fa-palette': FaPalette,
    'fas fa-layer-group': FaLayerGroup,
    'fas fa-envelope': FaEnvelope,
    'fa-bars': FaBars,
    'fa-times': FaTimes,

    // SEO subItems
    'fas fa-brain': FaBrain,
    'fas fa-globe-americas': FaGlobeAmericas,
    'fas fa-cogs': FaCogs,
    'fas fa-shopping-cart': FaShoppingCart,
    'fas fa-globe': FaGlobe,

    // Paid Media subItems
    'fas fa-search-dollar': FaSearchDollar,
    'fas fa-thumbs-up': FaThumbsUp,
    'fas fa-robot': FaRobot,
    'fas fa-facebook': FaFacebook,
    'fas fa-handshake': FaHandshake,

    // Data & AI subItems
    'fas fa-chart-bar': FaChartBar,
    'fas fa-tags': FaTags,

    // Strategy subItems
    'fas fa-clipboard-check': FaClipboardCheck,
    'fas fa-calendar-alt': FaCalendarAlt,
    'fas fa-home': FaHome,
    'fas fa-plane': FaPlane,
    'fas fa-code': FaLaptopCode,

    // Experience subItems
    'fas fa-paint-brush': FaPaintBrush,
    'fas fa-chart-line': FaChartLine,
    'fas fa-laptop-code': FaLaptopCode,
    'fas fa-video': FaVideo
};

// Helper function to get icon component
const getIconComponent = (iconName) => {
    return iconMap[iconName] || FaChevronRight;
};

// Island-style Top Navigation Component - Updated with centered logo
const ServicesTopNav = ({ onSidebarToggle }) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const navItems = [
        { label: 'Home', path: '/' },
        { label: 'Services', path: '/services', active: true },
        { label: 'About', path: '/about' },
        { label: 'Pricing', path: '/pricing' },
        { label: 'Blog', path: '/blog' },
        { label: 'Contact', path: '/contact' }
    ];

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <div className="">
            <TopNav />
        </div>
    );
};

// Footer Component
// ServicesFooter Component - Add this to your ServicesLayout.jsx
const ServicesFooter = () => {
    // State for social media links (you can manage this via props or context)
    const [socialLinks] = useState({
        youtube: 'https://youtube.com/@reachtix',
        linkedin: 'https://linkedin.com/company/reachtix',
        instagram: 'https://www.instagram.com/reachtix_agency?igsh=MTd6ankybDg0NnhjZw%3D%3D&utm_source=qr',
        telegram: 'https://t.me/@reachtix',
        facebook: 'https://www.facebook.com/share/1RGkqHo5EV/?mibextid=wwXIfr',
        whatsapp: 'https://wa.me/447943048610',
        X: 'https://x.com/reachtix?s=11'
    });

    // State for hover effects
    const [hoveredIcon, setHoveredIcon] = useState(null);

    return (
        <div className="cf-footer">
            <div className="cf-footer-top-section">
                <div className="cf-footer-container">
                    <div className="cf-footer-grid">
                        {/* Company Info Column */}
                        <div className="cf-footer-col">
                            <h5 className="cf-footer-heading cf-accent-text">Quantumcrest Solutions Ltd</h5>
                            <div className="cf-company-info">
                                <p className="cf-company-details">
                                    QUANTUMCREST SOLUTIONS LTD (trading as Reachtix)<br />
                                    Registered in England and Wales.<br />
                                    Company number: 16088299<br />
                                    Registered office: 400 Thames Valley Park Drive, Reading, RG6 1PT<br />
                                </p>
                            </div>
                        </div>

                        {/* Quick Contact Column */}
                        <div className="cf-footer-col">
                            <div className="cf-contact-section">
                                <h5 className="cf-footer-heading cf-accent-text">Quick Contact</h5>
                                <ul className="cf-contact-list">
                                    <li className="cf-contact-item">
                                        <FaEnvelope className="cf-accent-icon" />
                                        <a href="mailto:info@reachtix.com" className="cf-contact-link">
                                            info@reachtix.com
                                        </a>
                                    </li>
                                    <li className="cf-contact-item">
                                        <FaClock className="cf-accent-icon" />
                                        <p className="cf-contact-text">Opening Hours: 9.00 AM – 5.00 PM</p>
                                    </li>
                                    <li className="cf-contact-item">
                                        <FaPhone className="cf-accent-icon" />
                                        <a href="tel:447943048610" className="cf-contact-link">
                                            +44 118 228 7381
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Social Media Column */}
                        <div className="cf-footer-col">
                            <div className="cf-social-section">
                                <h5 className="cf-footer-heading cf-accent-text">Follow Us</h5>
                                <div className="cf-social-grid">
                                    {/* YouTube */}
                                    <a
                                        href={socialLinks.youtube}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={`cf-social-link ${hoveredIcon === 'youtube' ? 'cf-hovered' : ''}`}
                                        onMouseEnter={() => setHoveredIcon('youtube')}
                                        onMouseLeave={() => setHoveredIcon(null)}
                                        aria-label="YouTube"
                                    >
                                        <svg className="cf-social-icon" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                                        </svg>
                                        <span className="cf-social-name">YouTube</span>
                                    </a>

                                    {/* LinkedIn */}
                                    <a
                                        href={socialLinks.linkedin}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={`cf-social-link ${hoveredIcon === 'linkedin' ? 'cf-hovered' : ''}`}
                                        onMouseEnter={() => setHoveredIcon('linkedin')}
                                        onMouseLeave={() => setHoveredIcon(null)}
                                        aria-label="LinkedIn"
                                    >
                                        <svg className="cf-social-icon" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                                        </svg>
                                        <span className="cf-social-name">LinkedIn</span>
                                    </a>

                                    {/* Instagram */}
                                    <a
                                        href={socialLinks.instagram}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={`cf-social-link ${hoveredIcon === 'instagram' ? 'cf-hovered' : ''}`}
                                        onMouseEnter={() => setHoveredIcon('instagram')}
                                        onMouseLeave={() => setHoveredIcon(null)}
                                        aria-label="Instagram"
                                    >
                                        <svg className="cf-social-icon" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1 1 12.324 0 6.162 6.162 0 0 1-12.324 0zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4.965-10.405a1.44 1.44 0 1 1 2.881.001 1.44 1.44 0 0 1-2.881-.001z" />
                                        </svg>
                                        <span className="cf-social-name">Instagram</span>
                                    </a>

                                    {/* Telegram */}
                                    <a
                                        href={socialLinks.telegram}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={`cf-social-link ${hoveredIcon === 'telegram' ? 'cf-hovered' : ''}`}
                                        onMouseEnter={() => setHoveredIcon('telegram')}
                                        onMouseLeave={() => setHoveredIcon(null)}
                                        aria-label="Telegram"
                                    >
                                        <svg className="cf-social-icon" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.244-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
                                        </svg>
                                        <span className="cf-social-name">Telegram</span>
                                    </a>

                                    {/* WhatsApp */}
                                    <a
                                        href={socialLinks.whatsapp}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={`cf-social-link ${hoveredIcon === 'whatsapp' ? 'cf-hovered' : ''}`}
                                        onMouseEnter={() => setHoveredIcon('whatsapp')}
                                        onMouseLeave={() => setHoveredIcon(null)}
                                        aria-label="WhatsApp"
                                    >
                                        <svg className="cf-social-icon" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12 0C5.373 0 0 5.373 0 12c0 2.125.554 4.118 1.522 5.854L.532 23.242l5.524-1.027A11.942 11.942 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.826 0-3.585-.486-5.083-1.347l-.364-.215-3.912.727.746-3.698-.203-.38A9.96 9.96 0 0 1 2 12c0-5.514 4.486-10 10-10s10 4.486 10 10-4.486 10-10 10z" />
                                        </svg>
                                        <span className="cf-social-name">WhatsApp</span>
                                    </a>
                                    <a
                                        href={socialLinks.X}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={`cf-social-link ${hoveredIcon === 'x' ? 'cf-hovered' : ''}`}
                                        onMouseEnter={() => setHoveredIcon('x')}
                                        onMouseLeave={() => setHoveredIcon(null)}
                                        aria-label="x"
                                    >
                                        <div className="cf-social-icon" viewBox="0 0 24 24" fill="currentColor">
                                            <h2 clas>X</h2>
                                        </div>
                                        <span className="cf-social-name">twitter</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="cf-footer-bottom-section">
                <div className="cf-footer-container">
                    <div className="cf-footer-bottom-grid">
                        <div className="cf-copyright-section">
                            <p className="cf-copyright-text">
                                © {new Date().getFullYear()} <a href="https://reachtix.com/" target="_blank" rel="noopener noreferrer" className="cf-copyright-link">
                                    QUANTUMCREST SOLUTIONS LTD. All rights reserved.(D-U-N-S© Number: 232675067)
                                </a>
                            </p>
                        </div>
                        <div className="cf-footer-links">
                            <ul className="cf-footer-links-list">
                                <li>
                                    <Link to="/" className="cf-footer-link">
                                        Home
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/about" className="cf-footer-link">
                                        About
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/services" className="cf-footer-link">
                                        Services
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/contact-form" className="cf-footer-link">
                                        Contact
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/reachtix-privacy-policy" className="cf-footer-link">
                                        Privacy Policy
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/terms" className="cf-footer-link">
                                        Terms & Conditions
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
// Inner component
const ServicesLayoutContent = () => {
    useEffect(() => {
        window.scroll(0, 0);
        return () => {

        };
    }, []);
    const [broken, setBroken] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const [toggled, setToggled] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();
    const sidebarItems = servicesData.sidebarItems;

    // Handle responsive behavior
    useEffect(() => {
        const checkBroken = () => {
            if (window.innerWidth < 768) {
                setBroken(true);
                setToggled(false);
                setCollapsed(false); // Always show sidebar with text on mobile when open
            } else {
                setBroken(false);
            }
        };

        checkBroken();
        window.addEventListener('resize', checkBroken);
        return () => window.removeEventListener('resize', checkBroken);
    }, []);

    const handleSidebarToggle = () => {
        if (broken) {
            setToggled(!toggled);
        } else {
            setCollapsed(!collapsed);
        }
    };

    const handleItemClick = (path) => {
        navigate(path);
        if (broken) {
            setToggled(false);
        }
    };

    // Check if a path is active
    const isActive = (path) => location.pathname === path;

    return (
        <div className="services-page-container">

            <div className="services-layout">
                {/* ProSidebar */}
                <Sidebar
                    collapsed={false} // Never collapsed on mobile, always show text
                    toggled={toggled}
                    breakPoint="md"
                    onBreakPoint={setBroken}
                    className="services-sidebar"
                    width="280px"
                >
                    <div className="sidebar-header">
                        <h3><Link to='/services'>Services</Link></h3>
                        {broken && (
                            <Button color='info' className="sidebar-close" onClick={handleSidebarToggle}>
                                <FaTimes />
                            </Button>
                        )}
                    </div>

                    <Menu
                        rootStyles={{
                            padding: '0 15px',
                        }}
                        menuItemStyles={{
                            button: ({ level, active }) => {
                                const backgroundColor = active ? 'rgba(255, 255, 255, 0.15)' : 'transparent';
                                const hoverBackgroundColor = 'rgba(255, 255, 255, 0.1)';

                                return {
                                    borderRadius: '8px',
                                    margin: '5px 0',
                                    padding: '12px 15px',
                                    backgroundColor: level === 0 ? backgroundColor : 'transparent',
                                    color: 'white',
                                    '&:hover': {
                                        backgroundColor: hoverBackgroundColor,
                                    },
                                };
                            },
                        }}
                    >
                        {sidebarItems.map((category) => {
                            const CategoryIcon = getIconComponent(category.icon);

                            if (category.subItems?.length > 0) {
                                const isCategoryOpen = category.subItems.some(item =>
                                    isActive(item.path) || location.pathname.includes(item.path)
                                );

                                return (
                                    <SubMenu
                                        key={category.id}
                                        label={category.name}
                                        icon={<CategoryIcon />}
                                        defaultOpen={isCategoryOpen}
                                    >
                                        {/* "View All" link if category has path */}
                                        {category.path && (
                                            <MenuItem
                                                active={isActive(category.path)}
                                                onClick={() => handleItemClick(category.path)}
                                                icon={<FaLayerGroup />}
                                            >
                                                {category.name}
                                            </MenuItem>
                                        )}

                                        {category.subItems.map((item, index) => {
                                            const ItemIcon = getIconComponent(item.icon);
                                            return (
                                                <MenuItem
                                                    key={index}
                                                    active={isActive(item.path)}
                                                    onClick={() => handleItemClick(item.path)}
                                                    icon={<ItemIcon />}
                                                    suffix={item.isNew && <span className="badge-new">New</span>}
                                                >
                                                    {item.name}
                                                </MenuItem>
                                            );
                                        })}
                                    </SubMenu>
                                );
                            } else {
                                // Category without subitems
                                return (
                                    <MenuItem
                                        key={category.id}
                                        active={isActive(category.path)}
                                        onClick={() => handleItemClick(category.path)}
                                        icon={<CategoryIcon />}
                                    >
                                        {category.name}
                                    </MenuItem>
                                );
                            }
                        })}
                    </Menu>

                    <div className="sidebar-footer">
                        <Button
                            color='dark'
                            block
                            onClick={() => handleItemClick('/contact')}
                        >
                            <FaEnvelope />
                            <span className='mx-2'>Contact</span>
                        </Button>
                    </div>
                </Sidebar>

                {/* Main Content */}
                <main className={`main-content-wrapper ${toggled ? 'sidebar-open' : ''}`}>
                    <ServicesTopNav onSidebarToggle={handleSidebarToggle} />

                    <Outlet context={{ servicesData }} />
                    <ServicesFooter />

                </main>

            </div>

        </div>
    );
};

// Main component that wraps with ProSidebarProvider
const ServicesLayout = () => {
    return (
        <ProSidebarProvider>
            <ServicesLayoutContent />
        </ProSidebarProvider>
    );
};

export default ServicesLayout;